<template>
  <layout-full>
    <b-col cols="12" md="10" lg="8" xl="6">
      <slot/>
    </b-col>
  </layout-full>
</template>

<script>
import layoutFull from './layout-full'
export default {
  components: {
    layoutFull
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/auth-page.vue